<template>
  <div class="NewsCenterDetails" style="align-self: center;">
        <!-- 标题 -->
      <div class="flex-all-center mt-76">
        <p class="titletext">
          {{ $t('newsCenterDetails2.text1') }}{{ $t('newsCenterDetails2.text2') }}
        </p>
      </div>
       <!-- 标题下图标 -->
    <div class="timeandaddress flex-all-center">
        <div class="mr-6"><img src="../../assets/images/time_icon.png" class="iconimg "></div>
        <div class="mr-38">{{ $t('newsCenterDetails2.text3') }}</div>
        <div class="mr-6"><img src="../../assets/images/postion_icon.png" class="iconimg"></div>
        <div>{{ $t('newsCenterDetails2.text4') }}</div>
    </div>
    <!-- 正文 -->
  <div class="main">
    <div class="maintext ">
      <p>{{ $t('newsCenterDetails2.text5') }}</p>
      <div class="flex-all-center">
        <video id="playerId" class="video-js vjs-default-skin video " 
        controls preload="none"
        poster="../../assets/images/NewsCenter_pic2.png"
        data-setup="{}">
        <source src="https://static-dev.aicarb.com/blacklocustcap/videos/%E5%87%BA%E6%B5%B7%E4%B8%AD%E4%B8%9C1%E5%88%86%E9%92%9F.mp4" type='video/mp4' />
        </video>
      </div>

    </div>
    <div>
      
    </div>
  </div>
  <div class="footer"></div>
</div>
</template>

<script>
import 'video.js/dist/video-js.css';
// import videojs from 'video.js';

export default {
  name: "NewsCenterDetails2",
  components: {
    // Tabbar,
  },
  data() {
    return {
    };
  },
  computed: {},
  created() {},
  methods: {},

};


</script>

<style lang="scss" scoped>
.NewsCenterDetails
{
    color: #000;
    width: 100%;
}

.titletext
{
  font-family: "OPPO-B";
  max-width: 990px;
  line-height: 60px;
  font-size: 42px;
  text-align: center;
}

.main
{
  display: flex;
  align-items: center;
  justify-content: center;
}

.maintext
{
   text-indent: 32px;
   text-align:justify;
   max-width: 990px;
   width: 100%;
   line-height: 32px;
   p{
    margin-top: 40px;
    font-family:"OPPO-R";
    font-size: 16px;
   }
   .maintitie
   {
    text-align: center;
    font-family: "OPPO-B";
    font-size: 28px;
   }
}

.timeandaddress
{
    color: #909399;
    margin-top: 37px;
    font-family: "OPPO-R";
    font-size: 16px;
}

.iconimg
{
    width: 17px;
    height: auto;
    position:relative;
    top: 2px;
}

.footer
{
  margin-top: 120px;
}

.video
{
  width: 90%;
  height:auto;
  margin-top: 40px;
}

@media (max-width: 768px) {
  .titletext
{
  width: 90%;
}
  .main
{
  display: flex;
  flex-wrap: wrap;
}

.maintext
{
   text-indent: 32px;
   font-family: "OPPO-R";
   font-size: 17px;
   line-height: 32px;
   width: 90%;

   p{
    font-family:"OPPO-R";
    font-size: 16px;
    
   }
   .maintitie
   {
    text-align: center;
    font-family: "OPPO-B";
    font-size: 28px;
    margin-top: 40px;
   }
}

.footer
{
  margin-top: 40px;
}

.video
{
  width: 90%;
  height: auto;
  margin-top: 40px;
}
}
</style>